import { useTranslation } from 'contexts/Localization'
import React, { Dispatch, SetStateAction } from 'react'
import { QuestCategory } from 'state/vvsgotchi/models'
import { Text, TabMenu, Tab } from 'vvs-uikit'
import PixelatedImage from 'views/VvsGotchi/components/PixelatedImage'
import { StyledTabItem } from './styles'

interface Props {
  category: QuestCategory
  setCategory: Dispatch<SetStateAction<Exclude<QuestCategory, QuestCategory.ONBOARDING>>>
}

const IDX_TO_CATEGORY = [
  QuestCategory.DAILY_WORK,
  QuestCategory.SPECIAL_MISSION,
  QuestCategory.GAME_CHALLENGES,
] as const
const CATEGORY_TO_IDX = Object.fromEntries(IDX_TO_CATEGORY.map((c, i) => [c, i]))

export const SubNav: React.FC<Props> = ({ category, setCategory }) => {
  const { t } = useTranslation()
  const handleItemClick = (idx: number) => {
    setCategory(IDX_TO_CATEGORY[idx])
  }
  return (
    <TabMenu variant="altered" isEvenly activeIndex={CATEGORY_TO_IDX[category]} onItemClick={handleItemClick}>
      <Tab>
        <StyledTabItem>
          <PixelatedImage height="20px" src="/images/vvsGotchi/quest_category/daily_work.png" alt={t('Daily Work')} />
          <Text fontSize="14px" color="inherit">
            {t('Daily Work')}
          </Text>
        </StyledTabItem>
      </Tab>
      <Tab>
        <StyledTabItem>
          <PixelatedImage height="20px" src="/images/vvsGotchi/quest_category/special.png" alt={t('Daily Work')} />
          <Text fontSize="14px" color="inherit">
            {t('Special Mission')}
          </Text>
        </StyledTabItem>
      </Tab>
      <Tab>
        <StyledTabItem>
          <PixelatedImage height="20px" src="/images/vvsGotchi/controller.png" alt={t('Challenges')} />
          <Text fontSize="14px" color="inherit">
            {t('Challenges')}
          </Text>
        </StyledTabItem>
      </Tab>
    </TabMenu>
  )
}
